import { render, staticRenderFns } from "./TimeSlice.vue?vue&type=template&id=f127ba5a&"
import script from "./TimeSlice.vue?vue&type=script&lang=js&"
export * from "./TimeSlice.vue?vue&type=script&lang=js&"
import style0 from "./TimeSlice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports